import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainpageComponent } from './course-fee/mainpage/mainpage.component';

import { CampusLandingpageComponent } from './campus-Track/campus-landingpage/campus-landingpage.component';
import { CampusLandingLinksComponent } from './campus-Track/campus-landing-links/campus-landing-links.component';
import { LandingPageComponent } from './course-Track/landing-page/landing-page.component';

const routes: Routes = [
  {
    path:'',component:CampusLandingLinksComponent,
    children:[
      {
        path:"courseMaster", component:MainpageComponent
      },
      {
        path:"campus-Track",component:CampusLandingpageComponent
      },
      {
        path:"course-Track",component:LandingPageComponent
      },
    ]
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseMasterRoutingModule { }
